import {ButtonGroup, Dropdown, Header, Image} from "semantic-ui-react";
import {useAppDispatch} from "../../app/hooks";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";
import logo from "../../Ll.png";
import {ChangeSelectedCompany} from "../Auth/AuthActions";
import {Link} from "react-router-dom";
import {useState, useEffect} from "react";
import { ProfileMenu } from "../Header/ProfileMenu";

export const CompanyHeader = ({children}: any) => {
  const dispatch = useAppDispatch();
  const {companyId, companyName, rights} = useSelector((state: RootState) => state.auth);
  const rightsOptions = rights.map((company) => {
    return {key: company.companyId, text: company.companyName, value: company.companyId};
  });
  const [selectedCompany, setSelectedCompany] = useState(companyId);
  const [isChanging, setIsChanging] = useState(false);

  // sync with redux
  useEffect(() => {
    setSelectedCompany(companyId);
  }, [companyId]);

  const handleDropdownChange = async (e: any, data: any) => {
    if (isChanging || data.value === companyId) return;
    
    setIsChanging(true);
    try {
      await dispatch(ChangeSelectedCompany(data.value));
      setSelectedCompany(data.value);
    } catch (error) {
      setSelectedCompany(companyId);
    } finally {
      setIsChanging(false);
    }
  };

  return (
    <>
      <div className="headerContainer" style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        <div style={{display: "flex", alignItems: "center", overflow: "hidden"}}>
          <Link to="/">
            <Header as="h3">
              <Image src={logo} size="medium" verticalAlign="middle" />
            </Header>
          </Link>
          {children}
        </div>
        <div className="header-button-gr">
          <ButtonGroup size="small" color="blue" basic style={{ marginLeft: 10 }}>
            <Dropdown button text={companyName} compact fluid className="header-btn" floating options={rightsOptions} value={selectedCompany} onChange={handleDropdownChange} />
          </ButtonGroup>
          <ButtonGroup style={{ marginLeft: 5 }} basic size="small">
            <ProfileMenu />
          </ButtonGroup>
        </div>
      </div>
    </>
  );
};
